export const OTP_METHOD = {
  SMS: "SMS",
  EMAIL: "email",
};

export const VERIFY_KEY =
  process.env.NEXT_PUBLIC_VERIFY_PHONE_NO_KEY || "test1234abcd";
